<script>
import Titre from "@/components/atoms/titre";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";
import LazyImage from "@/components/atoms/lazy-image";
import dateUtils from "@/utils/date";
import HtmlParser from "@/components/organisms/cms-container/html-parser";

export default {
  name: "FicheAboLad",
  components: {
    Titre,
    Icon,
    ButtonIcon,
    LazyImage,
    Button,
    HtmlParser
  },
  props: {
    article: {
      type: Object,
      required: true
    },
    magasin: {
      type: Object,
      required: false,
      default: () => []
    }
  },
  methods: {
    formattedDatePublication(date) {
      return dateUtils.formatArticleBlogDate(date);
    }
  }
};
</script>

<template>
  <div class="u-bgcolor-white u-pt-sm@sm u-pb-xlg@sm u-mb-lg@sm">
    <div class="u-mb-md u-none@sm">
      <ButtonIcon
        variant="primary"
        icon-name="arrow-left"
        icon-color="primary"
        icon-color-hover="primary-light"
        icon-size="xs"
        link
        class="u-ml-xs"
        :to="`/magasins/${magasin.attributes.aliasWeb}-m-${magasin.id}/blog`"
      >
        Retour au blog
      </ButtonIcon>
    </div>
    <div class="c-page-article ">
      <Titre
        tag="h2"
        size="lg"
        variant="primary"
        class="u-mb-xs"
      >
        {{ article.attributes.titre }}
      </Titre>
      <p
        v-if="article.attributes.date_publication"
        class="u-color-text-light u-font-12 u-mb-md"
      >
        publié le {{ formattedDatePublication(article.attributes.date_publication) }}
      </p>
      <LazyImage
        v-if="article.attributes.image"
        :style="{ width: '100%' }"
        :src="article.attributes.image"
        class="u-mb-md"
      />
      <div
        v-if="article.attributes.contenu"
        class="u-mb-md"
      >
        <HtmlParser :content="article.attributes.contenu" />
      </div>

      <div class="u-text-center@sm">
        <ButtonIcon
          v-if="article.attributes.url_pdf && article.attributes.name_pdf"
          icon-name="document"
          icon-size="md"
          size="xlg"
          icon-color="primary"
          icon-color-hover="primary-light"
          outline
          radius="md"
          class="c-button--pdf"
          :href="article.attributes.url_pdf"
          target="__blanc"
        >
          <span class="u-flex u-flex-align-center">
            {{ article.attributes.name_pdf }}
            <Icon
              size="sm"
              name="download"
              variant="grey-2"
              class="u-ml-sm c-icon--download"
            />
          </span>
        </ButtonIcon>
        <br><br>
        <template v-if="article.attributes.url_action">
          <Button
            v-if="article.attributes.url_action.includes('cora.fr')"
            variant="primary"
            size="sm"
            radius="full"
            :href="article.attributes.url_action"
          >
            {{ article.attributes.titre_action }}
          </Button>
          <Button
            v-else-if="article.attributes.url_action.includes('http')"
            variant="primary"
            size="sm"
            radius="full"
            :href="article.attributes.url_action"
            target="__blanc"
          >
            {{ article.attributes.titre_action }}
          </Button>
          <Button
            v-else
            variant="primary"
            size="sm"
            radius="full"
            :to="article.attributes.url_action"
          >
            {{ article.attributes.titre_action }}
          </Button>
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.c-page-article {
  max-width: 68rem;
  margin-left: auto;
  margin-right: auto;
  padding: 0 2rem;
}
.c-button--pdf {
  &:hover {
    .c-icon {
      fill: color(primary-light);
    }
  }
}
</style>
